module.exports = __webpack_public_path__ + "img/logo.c34356a3.png";